import InspirationalSearchEntryPoint from '@/components/molecules/inspirational-search-entry-point/inspirational-search-entry-point';
import ModuleWrapper, {
  ModuleWrapperProps,
} from '@/components/utilities/module-wrapper/module-wrapper';

export interface InspirationalSearchEntryPointModuleProps
  extends ModuleWrapperProps {
  /** The link to show */
  link?: Content.Components['LinkDto'] | null;
  /** The text to show */
  text?: string;
}

const InspirationalSearchEntryPointModule = ({
  link,
  text,
  ...rest
}: InspirationalSearchEntryPointModuleProps) => {
  return (
    <ModuleWrapper {...rest}>
      <InspirationalSearchEntryPoint link={link} text={text} />
    </ModuleWrapper>
  );
};

InspirationalSearchEntryPointModule.displayName =
  'InspirationalSearchEntryPointModule';

export default InspirationalSearchEntryPointModule;
